// require("select2");
window.select2 = require('select2/dist/js/select2');
require("jquery.maskedinput/src/jquery.maskedinput");
require("jquery-ui-bundle/jquery-ui.min");
require("blueimp-file-upload/js/vendor/jquery.ui.widget");
require("blueimp-file-upload/js/jquery.iframe-transport");
require('blueimp-file-upload/js/jquery.fileupload');
window.resetFiles = function (e) {
    e.wrap('<form>').closest('form').get(0).reset();
    e.unwrap();
}
$(document).ready(function() {
    $.datepicker.regional.ru = {
        closeText: "Закрыть",
        prevText: "&#x3C;Пред",
        nextText: "След&#x3E;",
        currentText: "Сегодня",
        monthNames: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
        monthNamesShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
        dayNames: ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"],
        dayNamesShort: ["вск", "пнд", "втр", "срд", "чтв", "птн", "сбт"],
        dayNamesMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
        weekHeader: "Нед",
        firstDay: 1,
        isRTL: !1,
        showMonthAfterYear: !1,
        yearSuffix: ""
    };
    $.datepicker.regional.uk = {
        closeText: "Закрити",
        prevText: "&#x3C;",
        nextText: "&#x3E;",
        currentText: "Сьогодні",
        monthNames: ["Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень", "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"],
        monthNamesShort: ["Січ", "Лют", "Бер", "Кві", "Тра", "Чер", "Лип", "Сер", "Вер", "Жов", "Лис", "Гру"],
        dayNames: ["неділя", "понеділок", "вівторок", "середа", "четвер", "п’ятниця", "субота"],
        dayNamesShort: ["нед", "пнд", "вів", "срд", "чтв", "птн", "сбт"],
        dayNamesMin: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
        weekHeader: "Тиж",
        firstDay: 1,
        isRTL: !1,
        showMonthAfterYear: !1,
        yearSuffix: ""
    };
    $.datepicker.setDefaults($.datepicker.regional[$('html').attr('lang')]);
    if ($('.js-datepicker').length) {
        $(".js-datepicker").datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: "dd.mm.yy",
            // minDate: new Date(1922,1-1,1), maxDate: '-18Y',
            // yearRange: '-110:-18',
            // minDate: new Date('1922,1-1,1'),
            // maxDate: '+1m +1w',
            yearRange: "1922:+0"
        });
    }
    if ($('.js-datepicker-birth-date').length) {
        $(".js-datepicker-birth-date").datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: "dd.mm.yy",
            minDate: new Date(1922,1-1,1), maxDate: '-18Y',
            yearRange: '-110:-18',
        });
    }
    if ($('.js-datepicker-passport-date').length) {
        $(".js-datepicker-passport-date").datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: "dd.mm.yy",
            minDate: new Date(),
            maxDate: '+12Y',
            yearRange: '-0:+12',
        });
    }
    if ($('.js-select').length) {
        $('.js-select').select2();
    }
    $(document).on("click", ".js_validate button[type=submit], .js_validate input[type=submit]", function () {
        var valid = validate($(this).parents(".js_validate"));
        if (valid == false) {
            return false;
        }
        $(this).parents(".js_validate").on('submit', function () {
            var jsDisable = $(this).find('.js_disable');
            var jsLoading = $(this).find('.js_loading');
            jsDisable.attr('disabled', true);
            jsLoading.addClass('loading');

            setTimeout(function () {
                jsDisable.removeAttr('disabled');
                jsLoading.removeClass('loading')
            }, 30000);

            return true;
        });
    });
    if ($('input[name="code"]').length) {
        $('input[name="code"]').mask("9999999999");
    }
    if ($('input[type="tel"]').length) {
        $('input[type="tel"]').mask("+38 (999) 999-99-99", {
            placeholder: "+38 (___) ___-__-__"
        });
    }
    if ($('input[name="phone"]').length) {
        $('input[name="phone"]').mask("+38 (999) 999-99-99", {
            placeholder: "+38 (___) ___-__-__"
        });
    }
    if ($('input[name="field[rabochiy_telefon_kompanii]"]').length) {
        $('input[name="field[rabochiy_telefon_kompanii]"]').mask("+380 99 999 99 99", {
            placeholder: "+380 __ ___ __ __"
        });
    }
    if ($('input[name="field[kontaktniy_telefon_dovirenoyi_osobi]"]').length) {
        $('input[name="field[kontaktniy_telefon_dovirenoyi_osobi]').mask("+380 99 999 99 99", {
            placeholder: "+380 __ ___ __ __"
        });
    }
    if ($('input[name="field[kontaktnyy_telefon_doverennogo_lica]"]').length) {
        $('input[name="field[kontaktnyy_telefon_doverennogo_lica]').mask("+380 99 999 99 99", {
            placeholder: "+380 __ ___ __ __"
        });
    }
    if ($('input[name="field[seriya_pasporta]"]').length) {
        $.mask.definitions['h'] = "[а-яА-ЯїЇєЄіІёЁ]";
        $('input[name="field[seriya_pasporta]"]').mask("hh");
    }
    if ($('input[name="field[nomer_pasporta]"]').length) {
        $('input[name="field[nomer_pasporta]"]').mask("999999");
    }
    if ($('input[name="field[zapis_no]"]').length) {
        $('input[name="field[zapis_no]"]').mask("99999999-99999");
    }
    if ($('input[name="field[nomer_dokumenta]"]').length) {
        $('input[name="field[nomer_dokumenta]"]').mask("999999999");
    }
    if ($('input[name="field[postcode]"]').length) {
        $('input[name="field[postcode]"]').mask("99999");
    }
    if ($('input[name="field[test_pole_1]"]').length) {
        $('input[name="field[test_pole_1]"]').mask("99999");
    }
    if ($('.js-mask-num-card').length) {
        $('.js-mask-num-card').mask("9999");
    }
    if ($('.js-mask-сvv').length) {
        $('.js-mask-сvv').mask("999");
    }

    var clientFiles = $('.client-files');
    if(clientFiles.length){
        $.ajax({
            url: clientFiles.attr('data-url'),
            method: "get",
            dataType: "json",
            success: function (data) {
                if (data.success) {
                    for (var i in data.files) {
                        $('#client-files-' + i).html(data.files[i].join(''));
                    }
                } else {
                    // $('input[type="file"]').attr('required', true);
                }
            },
            error: function (error) {
            }
        });
    }

    $(document).on('change', 'input[type="file"]',
        function(e){
            var _this = $(this);
            var _type = _this.attr('data-file-type');
            var list = document.getElementById('fileList-' + _type);
            list.innerHTML = "";
            if (this.files.length) {
                _this.attr('required', true);
                var files = [];
                for (var i = 0; i < this.files.length; i++) {
                    files.push(this.files[i].name);
                    var li = document.createElement('li');
                    li.innerHTML = "<span class='js-remove-elem remove-elem' data-file-type='" + _type + "'></span>" + this.files[i].name;
                    list.append(li);
                }
            } else {
                $(this).parents('.form__item').find('.form-label-file').html($(this).attr('data-empty'));
                $(this).val('');
                _this.removeAttr('required');
            }
        }
    );
    $(document).on("click", ".js-remove-elem", function (e) {
        var _type = $(this).attr('data-file-type');
        $(this).parent().remove();
        resetFiles($('#upload-files-' + _type));
        $('#upload-files-' + _type).removeAttr('required');
    });
});



/* -------------------------------------------------------------------------
    begin Validation
    * ------------------------------------------------------------------------- */
$(document).ready(function () {

    setTimeout(function(){
        $(document).on("change", '.js_validate *[required]', function () {
            $(this).each(function () {
                var valid = validate($(document).find($(this)));
                if (valid == false) {
                    return false;
                } else {
                }
            });
        });
    }, 1);


    $('.js_validate .btn[type="submit"], .js_validate .js-validate-btn').on("click", function () {
        var valid = validate($(document).find($(this).parents(".js_validate")));
        if (valid == false) {
            return false;
        } else {
        }
    });


});

function formatValidate(inputFile) {
    function showMsg(massage) {
        $($($($(inputFile)[0]).siblings(".form-error"))[0]).text(massage);
        $(inputFile[0]).closest(".form__item__file").addClass("error");
        return false;
    }

    var format = [".pdf", ".txt", ".doc", ".docx", ".rtf", ".odt"];
    if ((inputFile)[0].files.length!=1) {
        showMsg($($(inputFile)[0]).attr("data-error-existence"));
        return false;
    } else {
        var file = (inputFile)[0].files;
        var fileName = file[0].name;
        if ((file[0].size/1024/1024) < 5) {
            for (var i = 0; i < format.length; i++) {
                if (-1 !== fileName.indexOf(format[i])) {
                    $($(inputFile)[0]).closest(".form__item__file").removeClass("error");
                    $($(inputFile)[0]).closest(".form__item__file").addClass("pass");
                    $($(inputFile)[0]).siblings(".form-error").text("");
                    return true;
                } else {
                    showMsg($($(inputFile)[0]).attr("data-error-type"));
                }
            }
        }
        else {
            showMsg($($(inputFile)[0]).attr("data-error-size"));
        }
    }
}


function validate(form) {
    var error_class = "error";
    var norma_class = "pass";
    var item = form.find("[required]");
    var e = 0;
    var reg = undefined;
    var pass = $('.password').val();
    var pass1 = $('.password_1').val();
    var passold = $('.password_old').val();
    var email = false;
    var password = false;
    var password_1 = false;
    var password_old = false;
    var password_one = false;
    var phone = false;
    var undef = false;
    var date = false;
    var number = false;
    var sum = false;
    var arr = [];

    function mark(object, expression, minSign, maxSign) {
        if (expression) {
            object.closest('.form__item').addClass(error_class).removeClass(norma_class);
            if (email) {
                if (object.val().length > 0) {
                    if (object.val().length < 6) {
                        object.closest('.form__item').find('.form-error').text(object.attr("data-error-min"));
                    }
                    else if  (object.val().length > 37) {
                        object.closest('.form__item').find('.form-error').text(object.attr("data-error-max"));
                    } else {
                        object.closest('.form__item').find('.form-error').text(object.attr("data-error-wrong"));
                    }
                } else {
                    object.closest('.form__item').find('.form-error').text(object.attr("data-error-empty"));
                }
            }
            if (password_old) {
                if (object.val().length > 0) {
                    if (object.val().length < 6) {
                        object.closest('.form__item').find('.form-error').text(object.attr("data-error-min"));
                    }
                    else if  (object.val().length > 20) {
                        object.closest('.form__item').find('.form-error').text(object.attr("data-error-max"));
                    }
                    else {
                        if(object.val()==pass||object.val()==pass1) {
                            object.closest('.form__item').find('.form-error').text(object.attr("data-error-wrong-old"));
                        } else {
                            object.closest('.form__item').find('.form-error').text(object.attr("data-error-wrong"));
                        }
                    }
                } else {
                    object.closest('.form__item').find('.form-error').text(object.attr("data-error-empty"));
                }
            }
            if (password) {
                if (object.val().length > 0) {
                    if (object.val().length < 6) {
                        object.closest('.form__item').find('.form-error').text(object.attr("data-error-min"));
                    }
                    else if  (object.val().length > 20) {
                        object.closest('.form__item').find('.form-error').text(object.attr("data-error-max"));
                    }
                    else {
                        if(object.val()==passold) {
                            object.closest('.form__item').find('.form-error').text(object.attr("data-error-wrong-old"));
                        // } else if (object.val()!==pass1) {
                        //     object.closest('.form__item').find('.form-error').text(object.attr("data-error-wrong-new"));
                        } else if (object.val()!==pass1) {
                            object.closest('.form__item').find('.form-error').text(object.attr("data-error-wrong-new"));
                        } else {
                            object.closest('.form__item').find('.form-error').text(object.attr("data-error-wrong"));
                        }
                    }
                } else {
                    object.closest('.form__item').find('.form-error').text(object.attr("data-error-empty"));
                }
            }
            if (password_one) {
                if (object.val().length > 0) {
                    if (object.val().length < 6) {
                        object.closest('.form__item').find('.form-error').text(object.attr("data-error-min"));
                    }
                    else if  (object.val().length > 20) {
                        object.closest('.form__item').find('.form-error').text(object.attr("data-error-max"));
                    }
                } else {
                    object.closest('.form__item').find('.form-error').text(object.attr("data-error-empty"));
                }
            }
            if (password_1) {
                if (object.val().length > 0) {
                    if (object.val().length < 6) {
                        object.closest('.form__item').find('.form-error').text(object.attr("data-error-min"));
                    }
                    else if  (object.val().length > 20) {
                        object.closest('.form__item').find('.form-error').text(object.attr("data-error-max"));
                    }
                    else {
                        if(object.val()==passold) {
                            object.closest('.form__item').find('.form-error').text(object.attr("data-error-wrong-old"));
                        }  else if (object.val()!==pass) {
                            object.closest('.form__item').find('.form-error').text(object.attr("data-error-wrong-new"));
                        } else {
                            object.closest('.form__item').find('.form-error').text(object.attr("data-error-wrong"));
                        }
                    }
                } else {
                    object.closest('.form__item').find('.form-error').text(object.attr("data-error-empty"));
                }
            }
            if (phone) {
                if (object.val().length < 1) {
                    object.closest('.form__item').find('.form-error').text(object.attr("data-error-empty"));
                }
            }
            if (date) {
                if (object.val().length != 4) {
                    object.closest('.form__item').find('.form-error').text(object.attr("data-error-empty"));
                } else {
                    object.closest('.form__item').find('.form-error').text(object.attr("data-error-wrong"));
                }
            }
            if (number) {
                if (object.val().length < 4 ||object.val().length > 100) {
                    object.closest('.form__item').find('.form-error').text(object.attr("data-error-empty"));
                } else {
                    object.closest('.form__item').find('.form-error').text(object.attr("data-error-wrong"));
                }
            }
            if (sum) {
                console.log(minSign);
                if (object.val().length < 1 || object.val() < minSign) {
                    object.closest('.form__item').find('.form-error').text(object.attr("data-error-empty"));
                } else {
                    object.closest('.form__item').find('.form-error').text(object.attr("data-error-wrong"));
                }
            }
            if (undef) {
                if (object.val().length > 0) {
                    if (object.val().length > minSign && object.val().length < maxSign) {
                        object.closest('.form__item').find('.form-error').text(object.attr("data-error-wrong"));
                    } else {
                        object.closest('.form__item').find('.form-error').text(object.attr("data-error-empty"));
                    }
                } else {
                    object.closest('.form__item').find('.form-error').text(object.attr("data-error-empty"));
                }
            }
            e++;
        } else {
            if($(object[0]).hasClass("select")) {
                if($(object[0]).prop("selectedIndex")!=0) {
                    object.closest('.form__item').addClass(norma_class).removeClass(error_class);
                    e = 0;
                } else {
                    object.closest('.form__item').addClass(error_class).removeClass(norma_class);
                    e = 0;
                }
            } else {
                object.closest('.form__item').addClass(norma_class).removeClass(error_class);
                e = 0;
            }
        }
        arr.push(expression);
    }

    if(form.hasClass('js_validate')) {
        var field = form.find("[required]"),
            // select = form.find('.js_valid_select'),
            inputContainer = form.closest('.js_valid_select'),
            select = inputContainer.find('select option'),
            radio = form.find('.js_valid_radio'),
            file = form.find('.form__item__file'),
            checkbox = form.find('.js_valid_checkbox');
        field.each(function () {
            var dataValidate = $(this).attr("data-validate");
            caseDataValidate(dataValidate, $(this));
        });
        select.each(function () {
            validSelect(form.find('.js_valid_select').find('select option'));
        });
        radio.each(function () {
            validRadio($(this).find('input[type="radio"]'));
        });
        checkbox.each(function () {
            validCheckbox($(this).find('input[type="checkbox"]'));
        });
        file.each(function () {
            validFile($(this).find('input[type="file"]'));
        });
    } else {
        var dataValidate =  form.attr("data-validate"),
            inputContainer = form.closest('.form__item'),
            field = form,
            select = inputContainer.find('select option'),
            radio = inputContainer.find('input[type="radio"]'),
            file = inputContainer.find('input[type="file"]'),
            checkbox = inputContainer.find('input[type="checkbox"]');
        if(inputContainer.hasClass('js_valid_select')) {
            validSelect(select);
        }
        else if(inputContainer.hasClass('js_valid_radio')) {
            validRadio(radio);
        }
        else if(inputContainer.hasClass('js_valid_checkbox')) {
            validCheckbox(checkbox);
        }
        else if(inputContainer.hasClass('form__item__file')) {
            validFile(file);
        }
        else {
            caseDataValidate(dataValidate, field);
        }
    }

    function caseDataValidate(dataValidate, fieldIn) {
        var minSign = fieldIn.attr("data-minsign");
        var maxSign = fieldIn.attr("data-maxsign");
        switch (dataValidate) {
            case "text":
                reg = new RegExp('^[\/\'"?!,.А-Яа-яёЁЇїІіЄєҐґa-zA-Z_0-9 -]{'+minSign+','+maxSign+'}$');

                undef = true;
                mark(fieldIn, !reg.test($.trim(fieldIn.val())), minSign, maxSign);
                undef = false;
                break;
            case "date":
                // reg = /^\d{2,10}[,.]?\d{2,10}[,.]?\d{2,10}$/;
                date = true;
                // mark(fieldIn, !reg.test($.trim(fieldIn.val())));
                mark(fieldIn, $.trim(fieldIn.val()).length === 0);
                date = false;
                break;
            case "number":
                //reg = /^\d+$/;
                reg = new RegExp('^[0-9]{'+minSign+','+maxSign+'}$');
                number = true;
                mark(fieldIn, !reg.test($.trim(fieldIn.val())));
                number = false;
                break;
            case "sum":
                //reg = /^\d+$/;
                reg = new RegExp('^[0-9]{'+minSign+', }$');
                sum = true;
                // mark(fieldIn, !reg.test($.trim(fieldIn.val())), minSign);
                mark(fieldIn, $.trim(fieldIn.val()).length === 0 || fieldIn.val() < minSign, minSign);
                sum = false;
                break;
            case "email":
                reg = /^([A-Za-z0-9_\-\.]{1,15})+\@([A-Za-z0-9_\-\.]{1,10})+\.([A-Za-z]{2,10})$/;
                email = true;
                if($.trim(fieldIn.val()).length>37) {
                    mark(fieldIn, true);
                } else {
                    mark(fieldIn, !reg.test($.trim(fieldIn.val())));
                }
                email = false;
                break;
            case "phone":
                phone = true;
                // reg = /[0-9-()+]{17}$/;
                reg = /[0-9- ()+]{10}$/;
                mark(fieldIn, !reg.test($.trim(fieldIn.val())));
                phone = false;
                break;
            case "passold":
                password_old = true;
                reg = /^[a-zA-Z0-9!#@_\-|]{6,20}$/;
                mark(fieldIn, (passold==pass||!reg.test($.trim(fieldIn.val()))||passold==pass1));
                password_old = false;
                break;
            case "pass":
                password = true;
                reg = /^[a-zA-Z0-9!#@_\-|]{6,20}$/;
                //mark(fieldIn, (pass1 !== pass||!reg.test($.trim(fieldIn.val()))||passold==pass));
                mark(fieldIn, ((pass1 !== pass && pass1 !== '')||!reg.test($.trim(fieldIn.val()))||passold==pass));
                password = false;
                break;
            case "passone":
                password_one = true;
                reg = /^[a-zA-Z0-9!#@_\-|]{6,20}$/;
                mark(fieldIn, (!reg.test($.trim(fieldIn.val()))));
                password_one = false;
                break;
            case "pass1":
                password_1 = true;
                reg = /^[a-zA-Z0-9!#@_\-|]{6,20}$/;
                mark(fieldIn, (pass1 !== pass||!reg.test($.trim(fieldIn.val()))||passold == pass1));
                password_1 = false;
                break;
            case "file":
                formatValidate(fieldIn);
                break;
            case "select2":
                if (fieldIn.val()) {
                    mark(fieldIn, false);
                    break;
                } else {
                    mark(fieldIn, true);
                    break;
                }

                // mark($(this), $.trim($(this).val()).length === 0);
                // break;
            default:
                reg = new RegExp(fieldIn.attr("data-validate"), "g");
                mark(fieldIn, !reg.test($.trim(fieldIn.val())));
                break;
        }
    }

// js_valid_select
    function validSelect(inp) {
        var rezalt = 0;
        for (var i = 1; i < inp.length; i++) {
            if ($(inp[i]).is('selected') === true || $(inp[i]).prop('selected') === true) {
                rezalt = 1;
                break;
            } else {
                rezalt = 0;
            }
        }
        if (rezalt === 0) {
            inp.closest('.form__item').addClass(error_class).removeClass(norma_class);
            e = 1;
        } else {
            inp.closest('.form__item').addClass(norma_class).removeClass(error_class);
            inp.closest('.form__item').addClass(norma_class).removeClass(error_class);

        }
    };


// js_valid_radio
    function validRadio(inp) {
        var rezalt = 0;
        for (var i = 0; i < inp.length; i++) {
            if ($(inp[i]).is(':checked') === true) {
                rezalt = 1;
                break;
            } else {
                rezalt = 0;
            }
        }
        if (rezalt === 0) {
            inp.closest('.form__item').addClass(error_class).removeClass(norma_class);
            e = 1;
        } else {
            inp.closest('.form__item').addClass(norma_class).removeClass(error_class);
        }
    };
// js_valid_checkbox
    function validCheckbox(inp) {
        var rezalt = 0;
        for (var i = 0; i < inp.length; i++) {
            if ($(inp[i]).is(':checked') === true) {
                rezalt = 1;
                break;
            } else {
                rezalt = 0;
            }
        }
        if (rezalt === 0) {
            inp.closest('.form__item').addClass(error_class).removeClass(norma_class);
            e = 1;
        } else {
            inp.closest('.form__item').addClass(norma_class).removeClass(error_class);
        }
    };

// js_valid_file
    function validFile(inp) {
        var rezalt = 0;
        for (var i = 0; i < inp.length; i++) {
            if (formatValidate(inp) == true) {
                rezalt = 1;
                break;
            } else {
                rezalt = 0;
            }
        }
        if (rezalt === 0) {
            inp.closest('.form__item').addClass(error_class).removeClass(norma_class);
            e = 1;
        } else {
            inp.closest('.form__item').addClass(norma_class).removeClass(error_class);
        }
    };
// js_valid_rating
//     form.find('.js-rating').each(function (indx, rating) {
//         var i = 0;
//         $(rating).find(".star").each(function (indx, star) {
//             if($(star).hasClass("active")) {
//                 i++;
//             } else {
//             }
//         });
//         if (i>0) {
//             $(this).addClass(norma_class).removeClass(error_class);
//         } else {
//             $(rating).addClass(error_class).removeClass(norma_class);
//             e = 1;
//         }
//     });

    if ($.inArray(true, arr) == -1 && e == 0) {
        return true;
    } else {
        form.find("." + error_class + " input:first").focus();
        return false;
    }
}

$('.form__item .delete').click(function() {
    var error_class = "error";
    var inp = $(this).siblings('input');
    var label = $(this).siblings('label');
    inp.val('');
    inp.closest('.form__item').removeClass(error_class);
    inp.closest('.form__item').removeClass("filled");
    if(inp[0].hasAttribute("data-error-existence")) {
        label.text(inp.attr("data-error-existence"));
    } else {
    }
});

/* -------------------------------------------------------------------------
 end Validation
 * ------------------------------------------------------------------------- */


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/elements/form.js